import styled from 'styled-components'

export default styled.hr`
    margin: 1em 12px 0.25em 15px;
    border-color: #555;
    border-width: 1px;
    width: 100hh;
`